<template>

    <section v-if="productLine" id="licenseInfo">
        <div class="container">
            <div class="text-title">License and Subscriptions</div>
            <div v-if="productLine.name == 'LoopCAD' || productLine.name == 'HeatCAD'">
                <p>
                    {{ productLine.name }} licensing is a combination of a perpetual license with subscription-based support and updates. With your initial license purchase, you automatically receive a 12-month subscription included at no additional charge. If the 12-month subscription expires and is not renewed you can continue to use your current version of {{ productLine.name }} indefinitely, but future program updates and technical support will no longer be available to you. When the expiry of this 12-month subscription is approaching, you will be prompted to renew the subscription in order to maintain uninterrupted software updates and support.
                </p>
                <p>
                    See the <router-link :to="{ name:'/support/faqs', params: { productLineParam: productLine.name.toLowerCase() }}">FAQ</router-link> page for more answers to licensing and subscription questions. Refer to the <router-link :to="{ name:'/store', params: { productLine: productLine.name.toLowerCase() }}">Pricing</router-link> page for up-to-date pricing information for license purchases and subscription renewals.
                </p>

                <q-markup-table separator="cell" wrap-cells class="q-mb-md" :dense="screenSize.xs">
                    <thead class="bg-primary text-white text-subtitle2 text-center">
                        <tr>
                            <td>Status</td>
                            <td style="border-left: 1px solid rgba(255, 255, 255, 0.25)">Features & Limitations</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <q-item class="statusItem">
                                    <q-item-section avatar class="gt-xs">
                                        <q-icon name="mdi-check-circle-outline" color="positive" />
                                    </q-item-section>
                                    <q-item-section :class="{'text-positive' : screenSize.xs}">Trial Active</q-item-section>
                                </q-item>
                            </td>
                            <td>
                                <ul class="listStyle">
                                    <li>
                                        Full feature set available
                                    </li>
                                    <li>
                                        "Trial" notations added to printouts
                                    </li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <q-item class="statusItem">
                                    <q-item-section avatar class="gt-xs">
                                        <q-icon name="mdi-alert-outline" color="negative" />
                                    </q-item-section>
                                    <q-item-section :class="{'text-negative' : screenSize.xs}">Trial Expired</q-item-section>
                                </q-item>
                            </td>
                            <td>
                                <ul class="listStyle">
                                    <li>The program changes to Reader-mode which allows opening and creating projects, but will not allow saving or exporting of project files</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <q-item class="statusItem">
                                    <q-item-section avatar class="gt-xs">
                                        <q-icon name="mdi-check-circle-outline" color="positive" />
                                    </q-item-section>
                                    <q-item-section :class="{'text-positive' : screenSize.xs}">
                                        License Purchased
                                        Subscription is Active
                                    </q-item-section>
                                </q-item>
                            </td>
                            <td>
                                <ul class="listStyle">
                                    <li>Full feature set available</li>
                                    <li>Free technical support</li>
                                    <li>Free training webinars</li>
                                    <li>Free program updates and version upgrades</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <q-item class="statusItem">
                                    <q-item-section avatar class="gt-xs">
                                        <q-icon name="mdi-alert-outline" color="negative" />
                                    </q-item-section>
                                    <q-item-section :class="{'text-negative' : screenSize.xs}">
                                        License Purchased
                                        Subscription is Expired
                                    </q-item-section>
                                </q-item>
                            </td>
                            <td>
                                <ul class="listStyle">
                                    <li>Full feature set available</li>
                                    <li>Telephone technical support not available</li>
                                    <li>E-mail technical support not available</li>
                                    <li>Training webinars not available</li>
                                    <li>Program updates/upgrades not available</li>
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </q-markup-table>
            </div>
            <div v-if="productLine.name == 'PlumbingCAD'">
                <p>PlumbingCAD licensing is subscription-based. With your subscription purchase, you get 12-months of software use. As the expiry of the 12-month subscription approaches, the software will prompt you to renew the subscription.</p>

                <p>If the 12-month subscription expires and is not renewed, PlumbingCAD will change to "Reader Mode". You will then be able to open and view existing project files, but you will not be able to create and save new projects, and you will not be able to save changes to existing projects.</p>

                <p>For up-to-date pricing information on subscription purchases or renewals please refer to the <router-link :to="{ name:'/store', params: { productLine: productLine.name.toLowerCase() }}">Pricing</router-link> page</p>

                <q-markup-table separator="cell" wrap-cells class="q-mb-md" :dense="screenSize.xs">
                    <thead class="bg-primary text-white text-subtitle2 text-center">
                        <tr>
                            <td>Status</td>
                            <td style="border-left: 1px solid rgba(255, 255, 255, 0.25)">Features & Limitations</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <q-item class="statusItem">
                                    <q-item-section avatar class="gt-xs">
                                        <q-icon name="mdi-check-circle-outline" color="positive" />
                                    </q-item-section>
                                    <q-item-section :class="{'text-positive' : screenSize.xs}">Trial Active</q-item-section>
                                </q-item>
                            </td>
                            <td>
                                <ul class="listStyle">
                                    <li>
                                        Full feature set available
                                    </li>
                                    <li>
                                        "Trial" notations added to printouts
                                    </li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <q-item class="statusItem">
                                    <q-item-section avatar class="gt-xs">
                                        <q-icon name="mdi-alert-outline" color="negative" />
                                    </q-item-section>
                                    <q-item-section :class="{'text-negative' : screenSize.xs}">Trial Expired</q-item-section>
                                </q-item>
                            </td>
                            <td>
                                <ul class="listStyle">
                                    <li>The program changes to Reader-mode</li>
                                    <li>Will not allow creating and saving of new projects</li>
                                    <li>Will not allow saving or exporting of project files</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <q-item class="statusItem">
                                    <q-item-section avatar class="gt-xs">
                                        <q-icon name="mdi-check-circle-outline" color="positive" />
                                    </q-item-section>
                                    <q-item-section :class="{'text-positive' : screenSize.xs}">
                                        Subscription is Active
                                    </q-item-section>
                                </q-item>
                            </td>
                            <td>
                                <ul class="listStyle">
                                    <li>Full feature set available</li>
                                    <li>Free technical support</li>
                                    <li>Free training webinars</li>
                                    <li>Free program updates and version upgrades</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <q-item class="statusItem">
                                    <q-item-section avatar class="gt-xs">
                                        <q-icon name="mdi-alert-outline" color="negative" />
                                    </q-item-section>
                                    <q-item-section :class="{'text-negative' : screenSize.xs}">
                                        Subscription is Expired
                                    </q-item-section>
                                </q-item>
                            </td>
                            <td>
                                <ul class="listStyle">
                                    <li>Reverts to "Reader" mode</li>
                                    <li>Will not allow creating and saving of new projects</li>
                                    <li>Will not allow saving of changes to existing projects</li>
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </q-markup-table>
            </div>
            <p>
                For complete licensing terms and conditions, view the <router-link :to="`/eula/${productLine.name.toLowerCase()}`">End-User License Agreement</router-link>.
            </p>
        </div>
    </section>
</template>
<script>
    export default {
        name: 'license-subscription-info',
        props: {
            productLine: Object,
        },
        data() {
            return {
            }
        },
        methods: {
        },
        computed: {
            screenSize() {
                return this.$q.screen
            },
        },
    }
</script>
<style lang="scss" scoped>
    @import "../styles/quasar.scss";

    @media (max-width: $breakpoint-xs-max) {
        .listStyle {
            padding-inline-start: 30px !important;
        }
    }

    .q-item__section--avatar {
        min-width: 0 !important;
    }

    .statusItem {
        font-weight: 500;
        font-size: 1.05em;
    }
</style>
